export default function modelNameTemplate(modelUrl: string) {
  return modelUrl.split('/').pop();
}
